import { useTranslation } from '@dreamstack/i18n'
import { RouterOutputs } from '@dreamstack/trpc/client'
import filter from 'lodash/filter'
import { useMemo } from 'react'
import { useUserId } from '../../../auth/src/lib/useUserId'
import { FeatureFlags } from '../config/featureflag.config'
import { useMyAccentroBaseUrl } from '../my/routing/useMyAccentroBaseUrl'

const navBarIds = {
  myAccentro: -1,
  overview: -2,
  documents: -3,
  profile: -4,
  messages: -5,
}

export const useMyAccentroNavEntry = () => {
  const t = useTranslation()
  const userId = useUserId()
  const myAccentroBaseUrl = useMyAccentroBaseUrl()

  return useMemo(() => {
    const now = new Date().toISOString()
    const staticPageStuff = {
      standalone: false,
      showNewsletterFooter: false,
      showContactFooter: false,
      removePaddingBottom: false,
      updatedAt: now,
      createdAt: now,
    }
    const items = !!userId
      ? ([
          {
            id: navBarIds.overview,
            position: 1,
            navType: 'Custom',
            featureFlag: null,
            staticPage: {
              id: 1,
              slug: myAccentroBaseUrl,
              pageTitle: 'Dashboard',
              ...staticPageStuff,
            },
            label: 'Dashboard',
            updatedAt: now,
            createdAt: now,
            subEntries: [],
          },
          {
            featureFlag: 'NBA_FLOW_ENABLED',
            id: navBarIds.documents,
            position: 2,
            navType: 'Custom',
            staticPage: {
              id: 2,
              slug: `${myAccentroBaseUrl}/documents`,
              pageTitle: 'Documents',
              ...staticPageStuff,
            },
            label: t('accentro:my.documents'),
            updatedAt: now,
            createdAt: now,
            subEntries: [],
          },
          {
            featureFlag: 'MY_PROFILE_ENABLED',
            id: navBarIds.profile,
            position: 3,
            navType: 'Custom',
            staticPage: {
              id: 3,
              slug: `${myAccentroBaseUrl}/profile`,
              pageTitle: 'Profile',
              ...staticPageStuff,
            },
            label: t('accentro:my.myProfile.profile'),
            updatedAt: now,
            createdAt: now,
            subEntries: [],
          },
          {
            featureFlag: 'MY_MESSAGES_ENABLED',
            id: navBarIds.messages,
            position: 4,
            navType: 'Custom',
            staticPage: {
              id: 4,
              slug: `${myAccentroBaseUrl}/messages`,
              pageTitle: 'Messages',
              ...staticPageStuff,
            },
            label: t('accentro:messages.title'),
            updatedAt: now,
            createdAt: now,
            subEntries: [],
          },
        ] satisfies (RouterOutputs['cms']['getNavEntries'][number] & {
          featureFlag: keyof typeof FeatureFlags | null
        })[])
      : []

    const filteredUrls = filter(items, (item) => {
      if (!item.featureFlag) return true
      else if (FeatureFlags[item.featureFlag]) return true
      else return false
    })

    return {
      label: t('accentro:myAccentro'),
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
      position: 0,
      navType: 'Custom' as const,
      staticPage: {
        id: 0,
        pageTitle: 'My Accentro',
        slug: myAccentroBaseUrl,
        standalone: false,
        updatedAt: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        showNewsletterFooter: false,
        showContactFooter: false,
        removePaddingBottom: false,
      },
      subEntries: filteredUrls,
      id: navBarIds.myAccentro,
    } satisfies RouterOutputs['cms']['getNavEntries'][number]
  }, [myAccentroBaseUrl, t, userId])
}
